import { Http } from "@/plugins/http.js";

export class CustomerDiseasesRepository {
  static cache = new Map();

  /**
   *
   * @return Promise<Disease[]>
   */
  static async getList(customerId) {
    const cacheKey = `getList-${customerId}`;

    if (CustomerDiseasesRepository.cache.has(cacheKey)) {
      return CustomerDiseasesRepository.cache.get(cacheKey);
    }

    const { data } = await Http.get(`v1/customers/${customerId}/diseases`, { params: { lang: "ru" } });
    const items = data.data ?? [];

    if (items.length) {
      CustomerDiseasesRepository.cache.set(cacheKey, items);
    }

    return items;
  }

  /**
   * Возвращает модель заболевания
   * @return Promise<Disease>
   */
  static getById(customerId, diseaseId) {
    return Http.get(`v1/customers/${customerId}/diseases/${diseaseId}`, { params: { lang: "ru" } }).then(
      response => response.data.data,
    );
  }

  /**
   * Удаляет заболевания пациента
   * @param {number} customerId
   * @param {number} diseaseId
   * @return {Promise<*>}
   */
  static removeById(customerId, diseaseId) {
    return Http.delete(`v1/customers/${customerId}/diseases/${diseaseId}`).then(response => response.data);
  }
}
